import React, { Component }    from 'react';
import { Link }                from 'react-router-dom';
import {connect}               from 'react-redux';
import FlashCarregando         from '../../../container/FlashCarregando';
import FlashRetornoNulo        from '../../../container/FlashRetornoNulo';
import { GetQuestaoProfessor } from '../../../actions/questaoActions';
import {SetError}              from '../../../actions/notificacaoAction';

class Professor_Questao extends Component {
   

    constructor(props){
      super(props);
      this.state = { load : false };
    }

    componentWillMount() {
      this.props.GetQuestaoProfessor(this.props.session.id).then((response) =>{
        this.setState({load:true});        
      }).catch((error) =>{
        this.props.SetError(500);
      });
    }

    renderListProfessorQuestao(){

          const retornoQueApro = this.props.allQuestaoProfessor;
          if(retornoQueApro.length>0) {
            return retornoQueApro.map((elem,i) =>{
            
               return  <tr key={i}>
                          <td className="text-center">{elem.due_que_id}</td>
                          <td className="text-left">{elem.due_que_pergunta}</td>
                          <td className="text-center">
                           <Link to={`${this.props.config.questao}/${elem.due_que_id}`} className="btn btn-primary btn-xs"><span className="glyphicon glyphicon-pencil"></span></Link>
                          </td>
                        </tr>
                  });

             }else{
                  return <tr> <td colSpan={3} className="text-center"><FlashRetornoNulo/></td></tr>;
             }

    }
 
    render() {

        if(!this.state.load){
          return  <FlashCarregando/>;
        }
  
        const lar1 = {width : '5%'}
        const lar2 = {width : '10%'}

        return(
              <div>
                <div className="panel panel-azul-claro panel-cinza">
                  <div className="panel-body">
                    <table className="table table_panel">
                      <thead>
                        <tr>
                          <th className="text-center" style={lar1}>#</th>
                          <th className="text-left">Pergunta</th>
                          <th className="text-center" style={lar2}>Editar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderListProfessorQuestao()}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );


    }


}

function mapStateToProps(state){

    return { 
             session             : state.auth.session,
             allQuestaoProfessor : state.questaoReducer.allQuestaoJogoProfessor,
             config              : state.configReducer.menu
            
           }
}

export default connect(mapStateToProps,{GetQuestaoProfessor,SetError})(Professor_Questao);


// WEBPACK FOOTER //
// ./src/components/professor/batalha/batalhar_professor_questao.js